import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/shared/lib/utils";

/**
 * Multi-line text input primitive. Raw `<textarea>` is out of spec in
 * component code (design.md §10); reach for this instead.
 *
 * Matches `Input`'s token discipline: glass-surface-subtle, rounded-lg,
 * type-body-base, px-4 inner padding so the `mx-4` on TextareaFormField's
 * label/error lines up with the text content.
 */
export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className, rows = 4, ...props }, ref) {
    return (
      <textarea
        ref={ref}
        rows={rows}
        className={cn(
          "w-full px-4 py-3 type-body-base resize-y",
          "rounded-lg border border-border",
          "glass-surface-subtle text-text placeholder:text-text-muted",
          "focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          className,
        )}
        {...props}
      />
    );
  },
);
